/**
 * api.js — Cliente HTTP centralizado para el backend Laravel.
 *
 * Usa axios con:
 *  - baseURL desde variable de entorno VITE_API_URL
 *  - Interceptor que agrega el token Bearer en cada petición
 *  - Manejador de errores 401 (cierra sesión automáticamente)
 */
import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: `${(import.meta.env.VITE_API_URL || 'https://cbrsancarlos.cl').replace(/\/+$/, '')}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// ── Interceptor de Request: adjunta el token Bearer ──────────────────────
api.interceptors.request.use((config) => {
  const stored = localStorage.getItem('cbr_auth');
  if (stored) {
    try {
      const { token } = JSON.parse(stored);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      localStorage.removeItem('cbr_auth');
    }
  }
  return config;
});

// ── Interceptor de Response: manejo centralizado de errores ──────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    // 401 Unauthorized: Sesión expirada o token inválido
    if (status === 401) {
      localStorage.removeItem('cbr_auth');
      window.location.href = '/';
    }

    // 429 Too Many Requests: Límite de tasa excedido
    if (status === 429) {
      toast.error('Demasiadas peticiones. Por favor, espera un momento antes de reintentar.', { 
        id: 'rate-limit',
        duration: 5000 
      });
    }

    return Promise.reject(error);
  }
);

export default api;
